module.exports = __webpack_public_path__ + "img/media_5.c85f4b4b.jpg";